// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2ioPS","list":"BalanceDue_list__1cwVx","listRow":"BalanceDue_listRow__1CxEO","total":"BalanceDue_total__FQd8g"};